import { UserType, UserTypeId } from '@halo/enums/user-type'
import { AccessRoleId, ExternalApiAccessRoleIds } from '@halo/enums/access-role.enum'

export class UserDto {
    public static fromApiResponse(fields: Partial<UserDto>): UserDto {
        const dto = new UserDto()
        Object.assign(dto, fields)
        return dto
    }

    public id: number
    public name: string
    public email: string
    public status_id: number
    public status: string
    public user_type_id: number
    public user_role_id: number
    public user_type: UserType
    public puuids: any[]
    public flags: string[]
    public is_db_user: boolean

    public get isInternalUser(): boolean {
        return this.user_type_id === UserTypeId.INTERNAL || this.user_type_id === UserTypeId.INTERNAL_API
    }

    public get isInternalApiUser(): boolean {
        return this.user_type_id === UserTypeId.INTERNAL_API
    }

    public get isExternalUser(): boolean {
        return this.user_type_id === UserTypeId.EXTERNAL || this.user_type_id === UserTypeId.EXTERNAL_API
    }

    public get isExternalApiUser(): boolean {
        return this.user_type_id === UserTypeId.EXTERNAL_API
    }

    public get isApiUser(): boolean {
        return (
            ExternalApiAccessRoleIds.includes(this.user_role_id) ||
            this.user_role_id === AccessRoleId.INTERNAL_API_USER ||
            // legacy api user type
            this.user_type_id === UserTypeId.INTERNAL_API ||
            this.user_type_id === UserTypeId.EXTERNAL_API
        )
    }

    public get isInternalDevUser(): boolean {
        return this.user_role_id === AccessRoleId.INTERNAL_DEVELOPER || (this.flags?.includes('PUSHLY_ENG') ?? false)
    }
}
